import { CompanyRole } from '../types/api/v2/obt/model/company-role';

export const companyRoles = {
  company: [CompanyRole.Org],
  tmc: [CompanyRole.Org, CompanyRole.Tmc],
};
